const config = {
    themeName: "Metronic",
    themeVersion: "8.0.33",
    demo: "demo1",
    main: {
        type: "default",
        primaryColor: "#009EF7",
        logo: {
            dark: "media/logos/logo-make-negativo.png",
            light: "media/logos/logo-make-positivo.png",
        },
    },
    illustrations: {
        set: "sketchy-1",
    },
    loader: {
        logo: "media/logos/logo-1-dark.svg",
        display: true,
        type: "default",
    },
    scrollTop: {
        display: true,
    },
    header: {
        display: true,
        menuIcon: "font",
        width: "fluid",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    toolbar: {
        display: true,
        width: "fluid",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    aside: {
        display: true,
        theme: "dark",
        fixed: true,
        menuIcon: "font",
        minimized: true,
        minimize: true,
        hoverable: true,
    },
    content: {
        width: "fluid",
    },
    footer: {
        width: "fluid",
    },
};
export default config;
//# sourceMappingURL=DefaultLayoutConfig.js.map